var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',{attrs:{"datetime":_vm.formattedDate}},[_vm._v(_vm._s(_vm.formattedDate))])
}
var staticRenderFns = []

export { render, staticRenderFns }